// SudokuGameRules.tsx

import React from 'react';
import '../../../../../../Assets/styles/LandingStyles/LandingComponentsStyles/BeginnersGuideStyles/SudokuGameRulesStyles/SudokuGameRules.css';
import GameControls from '../../../../../../Assets/images/GameRulesImages/InGameControls.png';
const GameRules = () => (

    <div className="notification-container">

        <p className="notification-text">
            🚨<strong>Important: </strong>Enable Notifications for Best Experience!
        </p>

        <div className="game-rules-container">
            {/* Left Column: Rules */}
            <div className="rules-section">
                <h2>Rules</h2>
                <ol>
                    <li>Accept or create a <strong>friendly or random match</strong> invite.</li>
                    <li>Player is <strong>randomly selected to go first.</strong></li>
                    <li>Players take turns until the board is complete.</li>
                    <li>Each <strong>turn lasts 60 seconds,</strong> with a limit of <strong>5 numbers per turn.</strong></li>
                    <li>Only <strong>1 hint</strong> is allowed per turn.</li>
                    <li>The player with <strong>the highest score wins</strong> the game.</li>
                    <li>In the event of a <strong>draw</strong>, the player with more inputs <strong>wins</strong> the game.</li>
                    <li>
                        If you do not end your turn within 24 hours, you automatically
                        forfeit the game.
                    </li>
                </ol>

                <div className="rules-warning">
                    Play your turn in 24 hrs or you will automatically forfeit game
                </div>
            </div>

            {/* Right Column: Game Controls + Scoring (stacked) */}
            <div className="controls-and-scoring">
                <div className="controls-section">
                    <h2>Game Controls</h2>

                    <img
                        src={GameControls}
                        alt="Game Controls Visual"
                        className="controls-image"
                    />

                    <ol>
                        <li>Use the <strong>Resign Flag</strong> to forfeit the game.</li>
                        <li>Use the <strong>Eraser</strong> to correct a mistake.</li>
                        <li>
                            Use <strong>End Turn</strong> if you have completed all your inputs
                            before the timer runs out.
                        </li>
                    </ol>
                </div>

                <div className="scoring-section">
                    <h2>Scoring</h2>
                    <ul>
                        <ul>
                            <li>
                                Earn <strong>1 point</strong> for <span className="correct">correct</span> number placement.
                            </li>
                            <li>
                                Lose <strong>1 point</strong> for each <span className="incorrect">incorrect</span> number placement.
                            </li>
                            <li>
                                Earn <strong>5 points</strong> for each row, column, and box <span className="solved">solved</span>.
                            </li>
                        </ul>
                    </ul>
                </div>
            </div>
        </div>

    </div>
);

export default GameRules;

